module.exports = __webpack_public_path__ + "img/20200401142712130.ed9bd140.png";